export default "__VITE_ASSET__aQjzyp5W__"